import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys, requestCCApi } from 'src/utils';

export const useUpdateAssemblyTag = () => {
  return useMutation({
    mutationFn: updateAssemblyTag,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.assemblyTags.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.viewAssemblyTagsWithAssembliesCount.invalidateAll(),
      );
    },
  });
};

const updateAssemblyTag = async (payload: {
  assemblyTagId: string;
  assemblyTag: string;
}) => {
  const request = {
    name: payload.assemblyTag,
  };

  const response = await requestCCApi({
    url: `/assemblyTags/${payload.assemblyTagId}`,
    method: 'PUT',
    data: { data: request },
  });

  return response;
};
